import React from 'react';

import { CardListSkeleton } from '../components/CardListSkeleton';
import type { SkeletonProps } from '../types';

export const createCardListSkeleton =
	(
		props: React.ComponentPropsWithoutRef<typeof CardListSkeleton>,
	): React.ComponentType<SkeletonProps> =>
	({ testId }: SkeletonProps): React.JSX.Element => <CardListSkeleton {...props} testId={testId} />;
